import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getCustomerDashboard } from "../../services/bookingService.js";
import { getCookie } from "../../utils/cookies.js";
import toast from "../../utils/toast.js";

const STATUS_BADGE = {
  confirmed: "badge-live",
  pending: "badge-warn",
  cancelled: "badge-danger",
};

function getStoredUserName() {
  try {
    return JSON.parse(getCookie("user"))?.name || "there";
  } catch {
    return "there";
  }
}

export default function OverviewCust() {
  const navigate = useNavigate();
  const userName = getStoredUserName();
  const [dashboard, setDashboard] = useState(null);

  useEffect(() => {
    fetchDashboard();
  }, []);

  async function fetchDashboard() {
    try {
      const res = await getCustomerDashboard();
      if (res.success) {
        setDashboard(res.data);
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Couldn't load your dashboard.");
    }
  }

  const recentBookings = dashboard?.recentBookings || [];

  return (
    <>
      <section className="dash-section active" data-section="overview">
        <div className="dash-welcome">
          <div>
            <h1 id="welcomeHeading">Welcome back, {userName} 👋</h1>
            <p>Where's your next trip?</p>
          </div>
          <button className="btn btn-primary" onClick={() => navigate("/panel_customer/bookride")}>
            🔍 Search cabs
          </button>
        </div>
        <div className="stats-grid stats-grid-2">
          <div className="stat-card">
            <span className="stat-icon">🎫</span>
            <div>
              <strong>{dashboard?.totalTrips ?? "—"}</strong>
              <span>Total trips</span>
            </div>
          </div>
          <div className="stat-card">
            <span className="stat-icon">📅</span>
            <div>
              <strong>{dashboard?.upcomingTrips ?? "—"}</strong>
              <span>Upcoming trips</span>
            </div>
          </div>
        </div>
        <div className="section-head-row">
          <h2>Recent bookings</h2>
          <button
            className="sidebar-jump-link"
            onClick={() => navigate("/panel_customer/booking")}
          >
            View all →
          </button>
        </div>

        {recentBookings.length > 0 ? (
          <div className="bookings-list">
            {recentBookings.map((booking) => (
              <article className="booking-card" key={booking.orderNumber}>
                <div className="booking-card-top">
                  <div>
                    <span className="booking-card-route">
                      {booking.fromCity} → {booking.toCity}
                    </span>
                    <span className="booking-card-order">Order # {booking.orderNumber}</span>
                  </div>
                  <span className={`booking-card-status ${STATUS_BADGE[booking.status] || "badge-muted"}`}>
                    {booking.status}
                  </span>
                </div>
                <div className="booking-card-meta">
                  <span className="meta-mode">
                    🧑‍🤝‍🧑{" "}
                    {typeof booking.seatsCount === "number"
                      ? `${booking.seatsCount} seat(s)`
                      : booking.seatsCount}
                  </span>
                  <span className="meta-date">📅 {booking.travelDate}</span>
                </div>
                <div className="booking-card-bottom">
                  <span className="booking-card-price">₹{booking.totalFare}</span>
                </div>
              </article>
            ))}
          </div>
        ) : (
          <div className="empty-state show">
            <h3>No trips yet</h3>
            <p>Search a route and book your first ride — per seat or the whole cab.</p>
            <button
              className="btn btn-primary"
              onClick={() => navigate("/panel_customer/bookride")}
            >
              🔍 Search cabs
            </button>
          </div>
        )}
      </section>
    </>
  );
}
